/**
 * Resolves with the analytics global once the deferred tracker script has run,
 * or null on timeout (script blocked, or HUGINN_ID unset). Test with `typeof`:
 * a bare `umami` throws a ReferenceError until the script loads.
 */
const whenReady = (timeoutMs = 5000): Promise<typeof umami | null> =>
  new Promise((resolve) => {
    if (typeof umami !== "undefined") {
      resolve(umami)

      return
    }
    const startedAt = Date.now()
    const poll = setInterval(() => {
      if (typeof umami !== "undefined") {
        clearInterval(poll)
        resolve(umami)
      } else if (Date.now() - startedAt >= timeoutMs) {
        clearInterval(poll)
        resolve(null)
      }
    }, 100)
  })

export default async (eventName: string, payload?: Record<string, unknown>) => {
  // Never track during SSR — there is no tracker and polling would hang
  if (typeof window === "undefined") {
    return
  }
  const tracker = await whenReady()
  if (!tracker) {
    return
  }
  try {
    await tracker.track(eventName, payload)
  } catch (error) {
    console.error("Huginn:", error)
  }
}
